import * as React from "react";
import { SVGProps } from "react";
const SvgLogoAi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-ai_svg__a)">
      <path
        d="M10.334 3.545 8.667 7.364l-4 1.59 4 1.591 1.667 3.819L12 10.545l4-1.59-4-1.591-1.666-3.819ZM2.75 5.375 3.667 8l.916-2.625 2.75-.875-2.75-.875L3.667 1 2.75 3.625 0 4.5l2.75.875Zm1.5 6.84-.583-1.67-.584 1.67-1.75.558 1.75.556L3.667 15l.583-1.67L6 12.772l-1.75-.557Z"
        fill="#FFB938"
      />
    </g>
    <defs>
      <clipPath id="logo-ai_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoAi;
